var executesOnLoad = [];


// Cookies
function openCookieSelection()
{

}

// Device Type
const bIsMobile = FLibrary.isMobile();
document.body.setAttribute("device", (bIsMobile ? "Mobile" : "Computer"));


let scrollOffsetPx = 65;

window.addEventListener("pageshow", event => {
  
  if (localStorage.getItem("cookie") === null) {
    executesOnLoad.push("openCookieSelection");
  }


  for (let scrollElement of document.querySelectorAll("[scroll]")) {
    UScroll.getOrCreate(scrollElement);
  }


  var isAtStart = true;
  var checkStart = function() {

    if( isAtStart !== ( window.scrollY <= scrollOffsetPx ) )
    {
      isAtStart = !isAtStart;

      if( isAtStart ) {
        document.body.classList.remove("scroll");
      }
      else {
        document.body.classList.add("scroll");
      }
    }

  }

  var isAtEnd = false;
  var checkEnd = function() {

    if( isAtEnd !== ( window.scrollY >= ( document.body.scrollHeight - window.innerHeight - scrollOffsetPx ) ) )
    {
      isAtEnd = !isAtEnd;

      if( isAtEnd ) {
        document.body.classList.add("scroll--end");
      }
      else {
        document.body.classList.remove("scroll--end");
      }
    }

  }
  
  var updateProgress = function(){};
  var elemProgressbar = document.getElementById("ScrollProBar");
  if( elemProgressbar )
  {
    elemProgressbar.classList.add("active");
    updateProgress = function()
    {
      let percent = window.scrollY / ( document.body.scrollHeight - window.innerHeight - scrollOffsetPx );
      elemProgressbar.style.transform = `translateX( -${ 101 * ( 1 - percent ) }% )`;
    }
  }

  window.addEventListener("scroll", function( event ) {

    checkStart();
    updateProgress();
    checkEnd();

  } );

  // Check on window load
  checkStart();
  updateProgress();
  checkEnd();


});


document.body.classList.add("transition--none");

window.addEventListener("pageshow", event => {
  
  requestAnimationFrame( function() { document.body.classList.remove("transition--none"); } )

});



var cursorHoverElement = undefined;
var cursorHoverStyle = "grab";
var cursorPressStyle = "grabbing";

window.addEventListener("mousedown", event => {

  if( window.getComputedStyle( event.target )["cursor"] === cursorHoverStyle )
  {
    cursorHoverElement = event.target;
    cursorHoverElement.style.cursor = cursorPressStyle;
  }

})

window.addEventListener("mouseup", event => {

  if( cursorHoverElement !== undefined )
  {
    cursorHoverElement.style.cursor = cursorHoverStyle;
    cursorHoverElement = undefined;
  }

})



